var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#B0C5C8}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_779472800"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999870 0c-4418128,0 -7999823,3581789 -7999823,7999917 0,4418022 3581695,8000083 7999823,8000083 4418128,0 8000083,-3582061 8000083,-8000083 0,-4418128 -3581955,-7999917 -8000083,-7999917zm154 2809950l4734073 2952025 -9468146 0 4734073 -2952025zm4793069 7666043l-484 0c0,473504 -383740,857185 -857185,857185l-7870799 0c-473504,0 -857185,-383740 -857185,-857185l0 -4526175c0,-50079 5114,-98776 13441,-146610l4523140 2820462c5551,3472 11469,5811 17173,9012 5976,3307 12059,6508 18130,9543 31949,16476 64854,29764 98504,38457 3472,957 6933,1382 10406,2185 36909,8693 74291,14138 111626,14138l272 -12c272,0 531,0 531,0 37335,0 74717,-5280 111626,-14138 3472,-850 6933,-1228 10406,-2185 33602,-8693 66402,-21969 98504,-38457 6083,-3035 12165,-6236 18130,-9543 5657,-3201 11622,-5551 17173,-9012l4523140 -2820462c8315,47835 13441,96425 13441,146610l12 4526187z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3993cde3d14d491177a781365bc161ec.svg";
export { ForwardRef as ReactComponent };